var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvaypLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 164,
    height: 41,
    viewBox: "0 0 164 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    transform: "translate(0.993 -0.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.669,28.293c.438,2.392,3.206,3.782,6.492,3.782,3.479,0,5.615-1.418,5.615-3.38,0-1.867-1.537-2.661-5.973-3.46l-3.97-.714C4.974,23.1.674,19.141.674,12.991.674,5.025,7.52,0,16.915,0c10.57,0,16.5,4.916,16.538,12.74H22.776c-.085-2.416-2.551-3.815-5.723-3.815s-4.879,1.418-4.879,3.21,1.7,2.638,5.657,3.352L21.8,16.2c8.486,1.541,12.489,5.025,12.489,11.454C34.293,35.809,27.938,41,17.038,41,6.794,41,.028,36.415,0,28.312Z",
    transform: "translate(-0.993 0.009)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M11.928,39.406,0,0H13.29l6.294,28.427H19.8L26.095,0H38.824L26.891,39.4Z",
    transform: "translate(31.258 0.989)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M13.521,39.677V27.11L0,0H12.423l6.94,16.069h.222L26.524,0H38.673L25.152,27.11V39.677Z",
    transform: "translate(90.643 0.594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M18.075,0C26.877,0,32.8,5.634,32.8,14.462c0,8.744-6.28,14.382-15.525,14.382H11.621V39.677H0V0ZM11.626,20.243h3.262c3.866,0,6.171-1.952,6.171-5.747s-2.305-5.719-6.091-5.719H11.621Z",
    transform: "translate(130.203 0.594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M26.891,0,38.824,39.4H25.529L19.24,10.979h-.222L12.729,39.4H0L11.913,0Z",
    transform: "translate(60.947 0.989)",
    fill: "#c2c2c2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvaypLogo);
export default __webpack_public_path__ + "static/media/svayp-logo.89eafe24f4b49ba8823a4e4037204349.svg";
export { ForwardRef as ReactComponent };